import emailValidator from '../../../utils/Validate';

export const emailValidationWithHookForm = (values: any): any => {
  let errors: any = {
    email: ''
  };
  if (!values.email || !values.email.replace(/\s/g, '').length) {
    errors.email = 'VALIDATORS.EMAIL_REQ';
  } else if (!emailValidator(String(values.email).toLowerCase())) {
    errors.email = 'VALIDATORS.INVALID_EMAIL';
  }
  if (!errors.email) {
    errors = {};
  }
  return errors;
};

export const emailValidationWithThanksHookForm = (values: any): any => {
  let errors: any = {
    email: ''
  };
  for (let i = 0; i < values.length; i++) {
    const value = values[i].trim();
    if (!value || !value.replace(/\s/g, '').length) {
      errors.email = 'VALIDATORS.EMAIL_REQ';
    } else if (!emailValidator(String(value).toLowerCase())) {
      errors.email = 'VALIDATORS.INVALID_EMAIL';
    }
  }
  if (!errors.email) {
    errors = {};
  }
  return errors;
};
